import React, { useState } from 'react';
import './App.css';
import NavbarSection from './sections/navbar/NavbarSection';
import HeroSection from './sections/hero/HeroSection';
import DescriptionSection from './sections/description/DescriptionSection';
import TableSection from './sections/table/TableSection';
import { AppProvider } from './context/AppContext';
import VerticalFlex from './components/flex_layouts/VerticalFlex';

function App() {
  const tabs = ['Immune modulation', 'Proliferation', 'Angiogenesis', 'Inflammation', 'Metabolism'];

  const [selectedTabId, setSelectedTabId] = useState(tabs[0]);
  const [freeSearchText, setFreeSearchText] = useState('');
  const [lastTableUpdateTime, setLastTableUpdateTime] = useState('');
  const [applyPagination, setApplyPagination] = useState(true);

  const getProviderValue = () => {
    return {
      tabs,
      selectedTabId,
      setSelectedTabId,
      freeSearchText,
      setFreeSearchText,
      lastTableUpdateTime,
      setLastTableUpdateTime,
      applyPagination,
      setApplyPagination,
    };
  };
  return (
    <AppProvider value={getProviderValue()}>
      <VerticalFlex>
        <NavbarSection />
        <HeroSection />
        <DescriptionSection />
        <TableSection />
      </VerticalFlex>
    </AppProvider>
  );
}

export default App;
